import LZString from "lz-string";
import * as z from "../../../../framework";
import { userHasRight } from "../../../../framework";
import VisibleInterval from "../../../../framework/core/visibleInterval";
import { Grid } from "../../ui";
import { Widget } from "./widget";
import orderRights from "../../../order/order/orderRights";
// tslint:disable-next-line:variable-name
export var W_SimpleGrid = function (widgetInstance?) {
    widgetInstance = widgetInstance || {};

    var widget = new Widget(widgetInstance);
    $.extend(this, widget);

    (this.widgetId = widgetInstance.WidgetId), (this.widget = true);
    this.widgetId = widgetInstance.WidgetId;
    (this.title = widgetInstance.title),
        (this.type = widgetInstance.type),
        (this.title = widgetInstance.title);
    this.type = widgetInstance.type;
    this.select = widgetInstance.select;
    this.expand = widgetInstance.expand;
    this.filter = widgetInstance.filter;
    this.columns = widgetInstance.columns;
    this.columnOrder = widgetInstance.columnOrder;
    this.orderBy = widgetInstance.orderBy;
    this.HTML = widgetInstance.HTML;

    this.divisions =
        widgetInstance.divisions === undefined
            ? true
            : widgetInstance.divisions;

    this.regions =
        widgetInstance.regions === undefined ? true : widgetInstance.regions;

    this.hideSearchOptions =
        widgetInstance.hideSearchOptions === undefined
            ? false
            : widgetInstance.hideSearchOptions;

    this.autoBind =
        widgetInstance.autoBind === undefined ? true : widgetInstance.autoBind;

    this.liveFilter =
        widgetInstance.liveFilter === undefined
            ? true
            : widgetInstance.liveFilter;

    this.divisionAndRegionOnly =
        widgetInstance.divisionAndRegionOnly === undefined
            ? false
            : widgetInstance.divisionAndRegionOnly;
};

W_SimpleGrid.prototype = {
    initAsync: function () {
        let me = this,
            widgets = {},
            deferred = $.Deferred();

        function initSimpleGrid(options) {
            options.gridOptions = options.gridOptions || {};
            options.gridOptions.allowExcelExport =
                options.gridOptions.allowExcelExport === undefined
                    ? false
                    : options.gridOptions.allowExcelExport;

            let originalId = options.gridOptions.id;

            options.gridOptions.id = `WI${me.instanceId}_${options.gridOptions.id}`;

            let gridOptions = options.gridOptions,
                jsonView = options.jsonView || "";

            jsonView = $.parseJSON(
                JSON.stringify(jsonView).replace(
                    originalId,
                    options.gridOptions.id
                )
            );

            gridOptions.stickyDefaultName =
                options.stickyDefaultName || originalId;

            let columnLayout = new Grid({
                id: options.gridOptions.id,
                zScreen: me,
                stickyDefaultName: gridOptions.stickyDefaultName
            });
            columnLayout.render(me.contents);

            gridOptions.widgetId = `Widget_${originalId}`;

            gridOptions.zScreen = me;
            me.buildGrid(gridOptions);

            if (gridOptions.stickyDefaultName === "OpenOrdersGrid") {
                if (!userHasRight(orderRights.viewAllAccessibleRegions)) {
                    let regionNumberElement = $(
                        `#${gridOptions.id}_Order_Region_RegionNumber`
                    );

                    if (regionNumberElement.length > 0) {
                        regionNumberElement.data(
                            "default",
                            z.user.myDefaultRegion.RegionName
                        );
                        regionNumberElement.disableAll(true);
                        regionNumberElement
                            .data("me")
                            .options.zSelect(z.user.myDefaultRegion);
                    }

                    $(`#${gridOptions.id}_filterDataButton`).click();
                }
            }

            deferred.resolve();
        }

        if (me.jsonView && me.gridOptions) {
            return initSimpleGrid({
                gridOptions: me.gridOptions,
                jsonView: me.jsonView
            });
        }

        if (localStorage.Widgets) {
            widgets = $.parseJSON(
                LZString.decompressFromUTF16(localStorage.Widgets)
            );
        }

        if (widgets[me.widgetId]) {
            initSimpleGrid(widgets[me.widgetId]);
        } else {
            z.ajax({
                type: "GET",
                url: `Widget/?ID=${me.widgetId}`
            }).done(function (response) {
                var options = JSON.parse(response.d.results.Options);

                widgets[me.widgetId] = options;
                localStorage.setItem(
                    "Widgets",
                    LZString.compressToUTF16(JSON.stringify(widgets))
                );

                initSimpleGrid(options);
            });
        }
        return deferred.promise();
    },
    // Komatsu is using this below, but we should avoid and create a  more generic method
    callFilterSearch: function (args) {
        let me = this,
            statusType = me.contents.find(`#${args.searchId}`).val();

        return args.searchFilters[statusType];
    },
    buildGrid: function (options) {
        var me = this;
        options.widget = true;
        options.originalFilter = options.filter;

        options.excelExport = function (e) {
            z.restoreExpr();

            let sheet = e.workbook.sheets[0],
                columnNumber = 0;

            for (var i = 0; i < this.columns.length; i++) {
                var column = this.columns[i];
                if (column.hidden || !column.template) {
                    continue;
                }
                var template = kendo.template(column.template);
                for (var j = 1; j < sheet.rows.length; j++) {
                    let row = sheet.rows[j],
                        data = e.data[j - 1];
                    row.cells[columnNumber].value = $(
                        $.parseHTML(template(data))
                    ).text();
                }
                columnNumber++;
            }

            $(`#${screenId}_WidgetContainer_PrintButton`).removeClass(
                "disabled"
            );
            me.contents.unmask();
        };

        if (options.filterFn) {
            options.filter = function () {
                return me[options.filterFn](options.filterArgs);
            };
        }
        options.autoBind = false;
        options.zScreen = me;
        options.defaultPageSize =
            options.defaultPageSize === undefined
                ? 10
                : options.defaultPageSize;

        var grid = z.controls.grid(options);
        grid.zRefresh();

        var interval =
            z.util.getOptionValue("WidgetRefreshInterval", 300) * 1000;
        var visibleInterval = new VisibleInterval(function () {
            // TODO: BUG: 16149 hide portal container so this fails when the session timeout screen comes up
            if (
                $("#PortalContainer").css("display") != "none" &&
                z.util.isGuid(z.getToken())
            ) {
                var id = $(`#${options.id}`).attr("id");
                if (id) {
                    $(`#${id}`).refreshGrid();
                }
            }
        }, interval);
        visibleInterval.start();

        let screenIndx = this.screenId.indexOf("_"),
            screenId = this.screenId.substr(0, screenIndx),
            printButton = $(`#${screenId}_WidgetContainer_PrintButton`);

        printButton.off().tie("click", function () {
            printButton.addClass("disabled");
            me.contents.mask();

            z.setExprAlwaysSafe();
            let kendoGrid = $(`#${options.id}`).data("kendoGrid");
            kendoGrid.options.excel.fileName = `${me.widgetName} Export.xlsx`;
            kendoGrid.saveAsExcel();
        });

        $(`#${options.Id}_filterDataButton`)
            .off()
            .tie("click", function () {
                me.get(`#${options.id}`).data("kendoGrid").dataSource.read();
            });

        if (
            options.mainEntity == "Call" ||
            options.mainEntity == "Order" ||
            options.mainEntity == "Contract" ||
            options.mainEntity == "OrderTemplate" ||
            options.mainEntity == "Quote"
        ) {
            var entityNumber = `${options.mainEntity.toLowerCaseFirstLetter()}Number`;

            $(`#${options.id}`).on("dblclick", "tbody>tr", function () {
                let selectedCountIndex =
                        $(".k-grid").find("tr.k-state-selected").length - 1,
                    dataItem = $(`#${options.id}`)
                        .data("kendoGrid")
                        .dataItem(
                            $(".k-grid").find("tr.k-state-selected")[
                                selectedCountIndex
                            ]
                        ),
                    entityParam = z.util.flatten(dataItem),
                    valueNumber = entityParam[`${options.mainEntity}Number`];

                if (options.mainEntity == "OrderTemplate") {
                    options.mainEntity = "Contract";
                }

                window.open(
                    `/${options.mainEntity}?${entityNumber}=${valueNumber}`,
                    "_blank"
                );
            });
        }
    }
};
